import ManagementReportContainer from './ManagementReportContainer';
export default ManagementReportContainer;